import React, { useEffect } from 'react';
import Layout from 'common/Layout';
import ErrorBoundary from 'common/ErrorBoundary';
import { useSelector } from 'react-redux';
import { Navigate, Outlet } from 'react-router-dom';
import { forceLogout, isTokenExpired } from '../apis/axiosConfig';

const PrivateRouter = () => {
  const user = useSelector((state) => state.user.response);
  const token = localStorage.getItem('token') || sessionStorage.getItem('userToken') || localStorage.getItem('userToken');
  const valid = Boolean((user || token || localStorage.getItem('user')) && !isTokenExpired(token));

  useEffect(() => {
    // 1. Initial check on mount
    const currentToken = localStorage.getItem('token') || sessionStorage.getItem('userToken') || localStorage.getItem('userToken');
    if (!currentToken || isTokenExpired(currentToken)) {
      forceLogout();
    }

    // 2. Periodic background check every 3 seconds for instant auto-logout
    const interval = setInterval(() => {
      const liveToken = localStorage.getItem('token') || sessionStorage.getItem('userToken') || localStorage.getItem('userToken');
      if (!liveToken || isTokenExpired(liveToken)) {
        forceLogout();
      }
    }, 3000);

    // 3. Multi-tab synchronization (logout across all tabs simultaneously)
    const handleStorageChange = (e) => {
      if (e.key === 'token' && (!e.newValue || isTokenExpired(e.newValue))) {
        forceLogout();
      }
    };
    window.addEventListener('storage', handleStorageChange);

    return () => {
      clearInterval(interval);
      window.removeEventListener('storage', handleStorageChange);
    };
  }, []);

  return (
    <div>
      {valid ? (
        <Layout>
          <ErrorBoundary>
            <Outlet />
          </ErrorBoundary>
        </Layout>
      ) : (
        <Navigate to={'/signin'} replace />
      )}
    </div>
  );
};

export default PrivateRouter;
